var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBienes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "51.83352080989876 324 1796.8953880764905 429.84000000000003",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    style: {
      maxHeight: 500
    },
    width: 1796.8953880764905,
    height: 429.84000000000003,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#Degradado_sin_nombre_81);\n      }\n\n      .st1 {\n        fill: url(#Degradado_sin_nombre_84);\n      }\n\n      .st2 {\n        fill: url(#Degradado_sin_nombre_82);\n      }\n\n      .st3 {\n        fill: url(#Degradado_sin_nombre_87);\n      }\n\n      .st4 {\n        fill: url(#Degradado_sin_nombre_83);\n      }\n\n      .st5 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: .79px;\n      }\n\n      .st6 {\n        fill: url(#Degradado_sin_nombre_86);\n      }\n\n      .st7 {\n        fill: url(#Degradado_sin_nombre_8);\n      }\n\n      .st8 {\n        fill: url(#Degradado_sin_nombre_85);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 566.54,
    x2: 1819.2,
    y1: 549.45,
    x1: 151.62,
    "data-name": "Degradado sin nombre 8",
    id: "Degradado_sin_nombre_8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004f9f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#0052a1",
    offset: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#005da7",
    offset: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#006fb3",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#0088c3",
    offset: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#00a9d7",
    offset: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#00d0f0",
    offset: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#00e7ff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Degradado_sin_nombre_8",
    y2: 563.63,
    x2: 1819.23,
    y1: 546.54,
    x1: 151.65,
    "data-name": "Degradado sin nombre 8",
    id: "Degradado_sin_nombre_81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Degradado_sin_nombre_8",
    y2: 610.7,
    x2: 1818.74,
    y1: 593.62,
    x1: 151.17,
    "data-name": "Degradado sin nombre 8",
    id: "Degradado_sin_nombre_82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Degradado_sin_nombre_8",
    y2: 605.45,
    x2: 1818.8,
    y1: 588.36,
    x1: 151.22,
    "data-name": "Degradado sin nombre 8",
    id: "Degradado_sin_nombre_83"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Degradado_sin_nombre_8",
    y2: 605.01,
    x2: 1818.8,
    y1: 587.92,
    x1: 151.23,
    "data-name": "Degradado sin nombre 8",
    id: "Degradado_sin_nombre_84"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Degradado_sin_nombre_8",
    y2: 602.56,
    x2: 1818.83,
    y1: 585.47,
    x1: 151.25,
    "data-name": "Degradado sin nombre 8",
    id: "Degradado_sin_nombre_85"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Degradado_sin_nombre_8",
    y2: 551.03,
    x2: 1819.36,
    y1: 533.95,
    x1: 151.78,
    "data-name": "Degradado sin nombre 8",
    id: "Degradado_sin_nombre_86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#Degradado_sin_nombre_8",
    y2: 610.7,
    x2: 1818.82,
    y1: 593.61,
    x1: 151.14,
    "data-name": "Degradado sin nombre 8",
    id: "Degradado_sin_nombre_87"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M393.65,625.63c0,52.6-42.37,94.97-94.97,94.97h-148.53v-340.9h137.33c50.64,0,91.55,41.4,91.55,91.55,0,31.65-15.58,57.47-39.93,72.56,32.14,13.63,54.54,43.83,54.54,81.81ZM184.24,411.83v118.83h103.25c31.65,0,57.47-26.3,57.47-59.41s-25.81-59.41-57.47-59.41h-103.25ZM359.56,625.63c0-34.57-27.28-62.82-60.88-62.82h-114.44v125.65h114.44c33.6,0,60.88-27.76,60.88-62.83Z",
    className: "st7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.91,402.09c0-12.66,10.23-23.38,23.38-23.38s23.38,10.72,23.38,23.38-10.23,23.38-23.38,23.38-23.38-10.71-23.38-23.38ZM447.22,477.09h32.14v243.5h-32.14v-243.5Z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.81,599.81c0,4.87-.49,10.23-.97,15.1h-213.8c6.82,49.67,45.3,80.36,96.92,80.36,38.47,0,65.26-18.02,78.41-41.4l28.25,16.56c-20.45,33.11-57.96,56-107.15,56-76.94,0-129.54-54.06-129.54-127.59s51.62-127.59,127.11-127.59,120.78,61.85,120.78,128.56ZM566.04,583.74h181.65c-6.81-53.57-45.77-81.33-87.66-81.33-51.13,0-87.65,33.6-93.99,81.33Z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1041.35,571.08v149.51h-32.15v-149.51c0-43.34-23.86-68.66-66.23-68.66s-78.89,25.33-78.89,90.58v127.59h-32.15v-243.5h32.15v37.99c18.99-30.68,47.24-43.83,81.81-43.83,59.41,0,95.45,38.96,95.45,99.83Z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1336.95,599.81c0,4.87-.49,10.23-.97,15.1h-213.8c6.82,49.67,45.3,80.36,96.92,80.36,38.47,0,65.26-18.02,78.41-41.4l28.25,16.56c-20.45,33.11-57.96,56-107.15,56-76.94,0-129.54-54.06-129.54-127.59s51.62-127.59,127.1-127.59,120.78,61.85,120.78,128.56ZM1122.19,583.74h181.65c-6.81-53.57-45.77-81.33-87.66-81.33-51.13,0-87.65,33.6-93.99,81.33Z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1545.88,656.31c0,41.4-36.04,70.13-88.15,70.13-48.7,0-81.82-24.83-93.99-56l27.27-16.07c8.76,24.83,34.09,40.9,66.72,40.9,28.73,0,56-10.23,56-38.96,0-60.39-142.21-25.81-142.21-115.42,0-38.96,34.58-69.64,83.28-69.64,39.93,0,71.1,19.48,85.22,49.67l-26.78,15.58c-10.23-24.83-35.06-34.09-58.44-34.09-25.33,0-51.14,12.18-51.14,38.47,0,60.39,142.21,25.81,142.21,115.42Z",
    className: "st8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1834.79,565.72h-86.68v86.69h-31.17v-86.69h-86.69v-31.17h86.69v-86.68h31.17v86.68h86.68v31.17Z",
    className: "st6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M779.85,614.92c.47-4.88.97-10.24.97-15.09,0-66.72-46.28-128.58-120.79-128.58s-127.11,56.01-127.11,127.61,52.6,127.58,129.56,127.58c49.19,0,86.69-22.89,107.14-56.01l-28.24-16.56c-13.15,23.39-39.95,41.39-78.4,41.39-51.63,0-90.11-30.68-96.93-80.34-2.38-25.46,0-31.19,0-31.19,6.32-47.71,42.86-81.31,93.99-81.31,40.42,0,78.1,25.83,86.83,75.79.33,1.81.6,3.65.84,5.52.43,12.35.37,22.65,0,31.19h32.15Z",
    className: "st3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    y2: 379.7,
    x2: 1833.19,
    y1: 379.7,
    x1: 66.73,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 727.68,
    x2: 1833.19,
    y1: 727.68,
    x1: 66.73,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 332.55,
    x2: 150.27,
    y1: 747.45,
    x1: 150.27,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 332.55,
    x2: 183.63,
    y1: 747.45,
    x1: 183.63,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 747.45,
    x2: 447.22,
    y1: 332.55,
    x1: 447.22,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 747.45,
    x2: 479.36,
    y1: 332.55,
    x1: 479.36,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 747.45,
    x2: 832,
    y1: 332.55,
    x1: 832,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 747.45,
    x2: 864.14,
    y1: 332.55,
    x1: 864.14,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 747.45,
    x2: 1009.34,
    y1: 332.55,
    x1: 1009.34,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 747.45,
    x2: 1041.48,
    y1: 332.55,
    x1: 1041.48,
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.69,583.73c-.23-1.87-.5-3.71-.84-5.52.5,1.71.77,3.55.84,5.52Z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 127.15,
    rx: 130.49,
    cy: 600.23,
    cx: 662.1,
    className: "st5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 94.55,
    rx: 97.03,
    cy: 600.23,
    cx: 662.1,
    className: "st5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 127.15,
    rx: 130.49,
    cy: 620.3,
    cx: 263.93,
    className: "st5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 94.55,
    rx: 97.03,
    cy: 620.3,
    cx: 263.93,
    className: "st5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 127.15,
    rx: 130.49,
    cy: 473.08,
    cx: 247.2,
    className: "st5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 94.55,
    rx: 97.03,
    cy: 473.08,
    cx: 247.2,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 583.74,
    x2: 805.12,
    y1: 583.74,
    x1: 520.36,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 614.91,
    x2: 520.36,
    y1: 614.91,
    x1: 802.63,
    className: "st5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 127.15,
    rx: 130.49,
    cy: 600.23,
    cx: 1217.53,
    className: "st5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 94.55,
    rx: 97.03,
    cy: 600.23,
    cx: 1217.53,
    className: "st5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(212.7 1443.27) rotate(-81.66)",
    ry: 118.78,
    rx: 128.82,
    cy: 598.55,
    cx: 941.49,
    className: "st5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(212.7 1443.27) rotate(-81.66)",
    ry: 88.33,
    rx: 95.79,
    cy: 598.55,
    cx: 941.49,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 583.74,
    x2: 1360.56,
    y1: 583.74,
    x1: 1075.79,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 614.91,
    x2: 1075.79,
    y1: 614.91,
    x1: 1358.06,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 533.55,
    x2: 1853.27,
    y1: 533.55,
    x1: 1613.64,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 564.72,
    x2: 1613.64,
    y1: 564.72,
    x1: 1851.17,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 698.81,
    x2: 1749.04,
    y1: 399.47,
    x1: 1749.04,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 399.47,
    x2: 1717.87,
    y1: 696.19,
    x1: 1717.87,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 506.54,
    x2: 1565.51,
    y1: 546.69,
    x1: 1495.25,
    className: "st5"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 643.73,
    x2: 1408.25,
    y1: 673.84,
    x1: 1358.06,
    className: "st5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 60.23,
    rx: 66.92,
    cy: 563.42,
    cx: 1455.1,
    className: "st5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 90.34,
    rx: 100.38,
    cy: 563.42,
    cx: 1455.1,
    className: "st5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 60.23,
    rx: 66.92,
    cy: 633.69,
    cx: 1455.1,
    className: "st5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 90.34,
    rx: 100.38,
    cy: 633.69,
    cx: 1455.1,
    className: "st5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBienes);
export default __webpack_public_path__ + "static/media/Bienes.ba2defbe272496e7777d702ea7e002c0.svg";
export { ForwardRef as ReactComponent };